import { BreaksMappingDestination } from 'app/constants/configuration/breaksMappingDestination'

export const getBreaksMappingDestination = (
  type: number,
): BreaksMappingDestination => {
  let breaksMappingDestination = BreaksMappingDestination.Duty50

  switch (type) {
    case 1:
      breaksMappingDestination = BreaksMappingDestination.Duty100
      break
    case 2:
      breaksMappingDestination = BreaksMappingDestination.Work
      break
  }

  return breaksMappingDestination
}
